/* 
 *  Copyright © Ludvik Michalek, Bigfoot Interactive
 *  http://www.bigfoot.cz/
 *  
 *  E-mail utils
 */

var EmailUtils = function(){};


/**
 * Static functions
 */


/**
 * Decode obfuscated email
 * @param {string} emailEnc
 * @returns {string}
 */
EmailUtils.decodeEmail = function(emailEnc, encodeSecret){
	var dec = StringUtils.rot13(emailEnc);
	dec = dec.replace('#!', '@')
	return dec.replace(encodeSecret, '');
};


EmailUtils.initEncodedEmailLinks = function(encodeSecret) {
	var INITED_CLASS_NAME = 'emailEncoded-inited';
	var links = $('a[data-email-enc]:not(.' + INITED_CLASS_NAME + ')');
	if (links.length > 0) {
		var prefixArr = [':','o','t','l','i','a','m'];
		var prefix = prefixArr.slice().reverse().join('');
		links.each(function () {
			var item = $(this);
			var emailEnc = String(item.data('emailEnc'));
			if(emailEnc.length > 0){
				var email = EmailUtils.decodeEmail(emailEnc, encodeSecret);
				item.attr('href', prefix + email);
				item.text(email);
			}
		});
		// set inited flag to processed items
		links.addClass(INITED_CLASS_NAME);		
	}
};
